import React, { useState } from "react";

const MODULOS = [
  { numero: 0, titulo: "Pacote completo: Módulos 2 a 5", preco: 89.9, de: 249.9 },
  { numero: 2, titulo: "Segurança na Prática", preco: 29.9, de: 69.9 },
  { numero: 3, titulo: "Pilotagem no Trânsito Urbano", preco: 29.9, de: 69.9 },
  { numero: 4, titulo: "Manutenção Básica", preco: 29.9, de: 69.9 },
  { numero: 5, titulo: "Aula Prática + Certificação (presencial em Sorriso-MT)", preco: 49.9, de: 99.9 },
];

function numeroInicial() {
  const parte = window.location.pathname.split("/").pop();
  if (parte === "pacote") return 0;
  const n = parseInt(parte, 10);
  return MODULOS.some(function (m) { return m.numero === n; }) ? n : MODULOS[0].numero;
}

const BASE_URL = "/api";

function formatarPreco(valor) {
  return valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export default function CursoRegistroPage() {
  const [etapa, setEtapa] = useState("form");
  const [moduloSelecionado, setModuloSelecionado] = useState(numeroInicial());
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [senha, setSenha] = useState("");
  const [aceite, setAceite] = useState(false); // giraia-legal-v1
  const [carregando, setCarregando] = useState(false);
  const [erroMsg, setErroMsg] = useState("");
  const [resultadoPix, setResultadoPix] = useState(null);
  const [copiado, setCopiado] = useState(false);

  const modulo = MODULOS.find((m) => m.numero === moduloSelecionado);

  async function handleSubmit(e) {
    e.preventDefault(); if (!aceite) return;
    e.preventDefault();
    setErroMsg("");

    if (!nome.trim() || !email.trim() || !telefone.trim() || !senha) {
      setErroMsg("Preencha todos os campos para continuar.");
      return;
    }
    if (senha.length < 6) {
      setErroMsg("A senha precisa ter pelo menos 6 caracteres.");
      return;
    }

    setCarregando(true);
    try {
      const resp = await fetch(`${BASE_URL}/auth/register-curso`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nome_completo: nome.trim(),
          email: email.trim(),
          telefone: telefone.trim(),
          senha,
          modulo_numero: moduloSelecionado,
        }),
      });

      const data = await resp.json();

      if (!resp.ok) {
        setErroMsg(data.detail || "Não foi possível concluir o cadastro. Tente novamente.");
        setEtapa("erro");
        return;
      }

      if (data.token) {
        localStorage.setItem("giraia_curso_token", data.token);
      }

      setResultadoPix(data);
      setEtapa("pix");
    } catch (err) {
      setErroMsg("Falha de conexão. Verifique sua internet e tente novamente.");
      setEtapa("erro");
    } finally {
      setCarregando(false);
    }
  }

  function copiarPix() {
    if (!resultadoPix?.pix_payload) return;
    navigator.clipboard.writeText(resultadoPix.pix_payload).then(() => {
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2500);
    });
  }

  return (
    <div
      className="min-h-screen bg-[#141118] text-[#F2F0EA] flex flex-col items-center px-4 py-10"
      style={{ fontFamily: "Manrope, sans-serif" }}
    >
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <img
            src="/logo-giraia.jpg"
            alt="Giraia Bike Shop Logo"
            className="w-44 h-44 sm:w-56 sm:h-56 mx-auto mb-4 object-contain"
          />
          <h1
            className="text-3xl sm:text-4xl font-black text-[#E2B84A] mb-2 tracking-tight"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Curso de Segurança
          </h1>
          <p
            className="text-lg text-[#E5E5E5] font-medium"
            style={{ fontFamily: "Manrope, sans-serif" }}
          >
            Patinetes, Bikes Elétricas e Scooters — Giraia Bike Shop
          </p>
        </div>

          {etapa === "form" && (
            <form
              onSubmit={handleSubmit}
              className="bg-[#1F1B26] rounded-2xl p-6 sm:p-8 space-y-6 shadow-xl"
            >
              <div>
              <div className="mb-4 rounded-xl border border-[#E2B84A] bg-[#E2B84A]/10 p-3 text-center text-[#E2B84A] font-semibold text-sm sm:text-base">🎉 Preço de lançamento até 30/11/2026</div>
                <label className="block text-[#F2F0EA] font-semibold mb-3 text-sm sm:text-base">
                  Escolha o módulo
                </label>
                <div className="grid gap-3">
                  {MODULOS.map((m) => (
                    <button
                      key={m.numero}
                      type="button"
                      onClick={() => setModuloSelecionado(m.numero)}
                      className={"w-full text-left px-4 py-3 rounded-xl border transition " + (moduloSelecionado === m.numero ? "border-[#E2B84A] bg-[#3A2F12] ring-2 ring-[#E2B84A]" : "border-[#3A3444] bg-[#1A1620]")}
                    >
                      <div className="flex items-center justify-between">
                        <span className="text-[#F2F0EA] font-medium">
                          {m.numero === 0 ? m.titulo : "Módulo " + m.numero + " — " + m.titulo}
                        </span>
                        <span className="text-[#E2B84A] font-bold">
                          {m.de && <s className="text-gray-400 text-sm mr-2">{formatarPreco(m.de)}</s>}{formatarPreco(m.preco)}
                        </span>
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              <div className="space-y-4">
                <input
                  type="text"
                  placeholder="Nome completo"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  required
                  className="w-full px-4 py-3 rounded-xl bg-[#1A1620] border border-[#3A3444] text-[#F2F0EA] placeholder-[#8A8494] focus:outline-none focus:border-[#E2B84A]"
                />
                <input
                  type="email"
                  placeholder="E-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full px-4 py-3 rounded-xl bg-[#1A1620] border border-[#3A3444] text-[#F2F0EA] placeholder-[#8A8494] focus:outline-none focus:border-[#E2B84A]"
                />
                <input
                  type="tel"
                  placeholder="Telefone (WhatsApp)"
                  value={telefone}
                  onChange={(e) => setTelefone(e.target.value)}
                  required
                  className="w-full px-4 py-3 rounded-xl bg-[#1A1620] border border-[#3A3444] text-[#F2F0EA] placeholder-[#8A8494] focus:outline-none focus:border-[#E2B84A]"
                />
                <input
                  type="password"
                  placeholder="Crie uma senha"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  required
                  minLength={6}
                  className="w-full px-4 py-3 rounded-xl bg-[#1A1620] border border-[#3A3444] text-[#F2F0EA] placeholder-[#8A8494] focus:outline-none focus:border-[#E2B84A]"
                />
              </div>

              {erroMsg && (
                <p className="text-red-400 text-sm text-center">{erroMsg}</p>
              )}

              {(Number(moduloSelecionado) === 5 || Number(moduloSelecionado) === 0) && (
                <div className="rounded-xl border border-gold-500 bg-[#1E1A24] p-4 text-base text-[#F2F0EA] mb-4">
                  <p className="font-bold text-[#E2B84A] mb-1">Antes de comprar a aula prática</p>
                  <p>A aula prática é para quem anda de bicicleta elétrica ou patinete elétrico. Quem anda de ciclomotor só participa se já tiver habilitação (ACC ou CNH). Menores de 18 anos participam com o responsável, que assina um termo de responsabilidade no dia da aula. Este é um curso livre de segurança e não substitui a formação de condutores feita pelas autoescolas.</p>
                </div>
              )}
              <label className="flex items-start gap-3 rounded-xl border border-[#2e2834] bg-[#1E1A24] p-4 mb-4 cursor-pointer text-base text-[#F2F0EA]">
                <input type="checkbox" checked={aceite} onChange={(e) => setAceite(e.target.checked)} className="mt-1 h-6 w-6 shrink-0 accent-[#E2B84A]" />
                <span>Sou maior de 18 anos, ou sou o pai, a mãe ou o responsável legal e autorizo este cadastro. Li e concordo com a{" "}
                  <a href="/privacidade.html" target="_blank" rel="noreferrer" className="underline text-[#E2B84A]">Política de Privacidade</a> e a{" "}
                  <a href="/cancelamento.html" target="_blank" rel="noreferrer" className="underline text-[#E2B84A]">Política de Cancelamento</a>.
                </span>
              </label>
              <button
                type="submit"
                disabled={carregando || !aceite}
                className="w-full py-3 rounded-xl bg-[#E2B84A] text-[#141118] font-bold text-lg disabled:opacity-60 transition hover:brightness-110"
              >
                {carregando ? "Enviando..." : "Continuar para pagamento PIX"}
              </button>
            </form>
          )}

          {etapa === "pix" && resultadoPix && (
            <div className="bg-[#1F1B26] rounded-2xl p-6 sm:p-8 text-center shadow-xl">
              <h2 className="text-xl sm:text-2xl font-bold text-[#E2B84A] mb-2" style={{ fontFamily: "Outfit, sans-serif" }}>
                Escaneie o QR Code para pagar
              </h2>
              <p className="text-[#F2F0EA] mb-4">
                Valor: <span className="font-bold text-[#E2B84A]">{formatarPreco(resultadoPix.valor)}</span>
              </p>
              <img
                src={"data:image/png;base64," + resultadoPix.pix_qrcode_base64}
                alt="QR Code PIX"
                className="w-56 h-56 sm:w-64 sm:h-64 mx-auto mb-4 rounded-xl bg-white p-2"
              />
              <p className="text-[#8A8494] text-sm mb-2">Ou copie o código PIX abaixo:</p>
              <div className="bg-[#1A1620] border border-[#3A3444] rounded-xl p-3 mb-4 break-all text-xs text-[#F2F0EA]">
                {resultadoPix.pix_payload}
              </div>
              <button
                type="button"
                onClick={() => {
                  navigator.clipboard.writeText(resultadoPix.pix_payload);
                  setCopiado(true);
                  setTimeout(() => setCopiado(false), 2500);
                }}
                className="w-full py-3 rounded-xl bg-[#E2B84A] text-[#141118] font-bold text-lg mb-3 transition hover:brightness-110"
              >
                {copiado ? "Copiado!" : "Copiar código PIX"}
              </button>
              <p className="text-[#8A8494] text-sm">
                {resultadoPix.message}
              </p>
              <div className="mt-5 rounded-xl border border-[#E2B84A] bg-[#141118] p-4 text-left">
                <p className="text-[#F2F0EA] text-base leading-relaxed">
                  <strong className="text-[#E2B84A]">Direito de desistência:</strong> você pode desistir da compra em até <strong>7 dias</strong> e receber <strong>100% do valor de volta</strong> pelo PIX, conforme o Código de Defesa do Consumidor. Para pedir, fale no WhatsApp (66) 99958-4198.{" "}
                  <a href="/cancelamento.html" target="_blank" rel="noreferrer" className="underline text-[#E2B84A]">Ver política de cancelamento</a>
                </p>
              </div>
            </div>
          )}

          {etapa === "erro" && (
            <div className="bg-[#1F1B26] rounded-2xl p-6 sm:p-8 text-center shadow-xl">
              <h2 className="text-xl sm:text-2xl font-bold text-red-400 mb-3" style={{ fontFamily: "Outfit, sans-serif" }}>
                Ops, algo deu errado
              </h2>
              <p className="text-[#F2F0EA] mb-6">{erroMsg}</p>
              <button
                type="button"
                onClick={() => setEtapa("form")}
                className="w-full py-3 rounded-xl bg-[#E2B84A] text-[#141118] font-bold text-lg transition hover:brightness-110"
              >
                Tentar novamente
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
